import { apiFetch, getApiBaseUrl } from './client';

const DEFAULT_API_BASE_URL = getApiBaseUrl();

function buildSummaryQuery(filters = {}) {
  const params = new URLSearchParams();

  const entries = {
    start: filters.start,
    end: filters.end,
    currency: filters.currency,
    eventId: filters.eventId,
    venueId: filters.venueId,
    productType: filters.productType,
    accountId: filters.accountId,
    limit: filters.limit,
  };

  Object.entries(entries).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, String(value));
  });

  return params.toString();
}

function buildSummaryPath(filters = {}) {
  const query = buildSummaryQuery(filters);
  if (!query) return '/api/revenue/summary';
  return `/api/revenue/summary?${query}`;
}

function buildSummaryPathFromQueryString(queryString = '') {
  if (!queryString) return '/api/revenue/summary';
  return `/api/revenue/summary?${queryString}`;
}

function readDataSourceHeader(response) {
  const raw = response.headers.get('X-Data-Source') || response.headers.get('x-data-source') || '';
  const value = raw.trim().toLowerCase();
  return value || null;
}

async function readSummaryError(response) {
  let errorMessage = `Failed to fetch revenue summary (${response.status})`;
  if (response.status === 401) {
    errorMessage = 'Your session has expired. Please sign in again.';
  }
  try {
    const payload = await response.json();
    if (payload?.detail?.message) errorMessage = payload.detail.message;
  } catch {
    // keep default
  }
  throw new Error(errorMessage);
}

async function parseSummaryResponse(response) {
  if (!response.ok) {
    await readSummaryError(response);
  }

  const data = await response.json();
  return {
    data,
    dataSource: readDataSourceHeader(response),
  };
}

export async function fetchRevenueSummary(filters = {}, options = {}) {
  const path = buildSummaryPath(filters);
  console.log('[fetchRevenueSummary] fetching:', `${DEFAULT_API_BASE_URL}${path}`);

  const controller = new AbortController();
  const signal = options.signal || controller.signal;
  let timeoutId = null;
  const timeout = typeof options.timeout === 'number' ? options.timeout : 180000;
  if (!options.signal) {
    timeoutId = setTimeout(() => controller.abort(), timeout);
  }

  const response = await apiFetch(path, {
    method: 'GET',
    signal,
  }).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });

  return parseSummaryResponse(response);
}

export async function fetchRevenueSummaryByQueryString(queryString = '', options = {}) {
  const path = buildSummaryPathFromQueryString(queryString);

  const controller = new AbortController();
  const signal = options.signal || controller.signal;
  let timeoutId = null;
  const timeout = typeof options.timeout === 'number' ? options.timeout : 180000;
  if (!options.signal) {
    timeoutId = setTimeout(() => controller.abort(), timeout);
  }

  const response = await apiFetch(path, {
    method: 'GET',
    signal,
  }).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });

  return parseSummaryResponse(response);
}
